import { tap, mapTo } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';

import { PublicOrganization } from '../services';

export function organizationInitializerFactory(
  prefix: string,
  publicOrganization: PublicOrganization,
  httpClient: HttpClient,
): () => Promise<boolean> {
  return () => {
    if (!prefix) {
      return Promise.resolve(false);
    }

    return httpClient
      .get(`/api/public/organizations/${prefix}/`)
      .pipe(
        tap((response) => publicOrganization.fromJSON(response)),
        mapTo(true),
      )
      .toPromise();
  };
}
